<template>
  <div ref="componentRef">
    <div class="relative">
      <span
        v-on:click="toggleDropdown()"
        :class="{
          flex: true,
          'flex-row': true,
          'gap-xs': true,
          'p-xs': true,
          'cursor-pointer': !props.disabled,
          'cursor-not-allowed': props.disabled,
          'select-none': true,
          'items-center': true,
        }"
      >
        <slot></slot>
        <font-awesome-icon
          class="text-text-brand"
          v-if="props.showChevron"
          :icon="
            state.showDropdown
              ? 'fa-regular fa-chevron-up'
              : 'fa-regular fa-chevron-down'
          "
        />
      </span>
      <ul
        class="absolute left-1/2 top-2xl z-20 w-[240px] -translate-x-1/2 rounded-md border border-thin border-[#c8c8c8] bg-white drop-shadow-md"
        v-if="state.showDropdown"
      >
        <slot name="dropdown"></slot>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { reactive, ref, watch } from "vue";

library.add(faChevronDown, faChevronUp);

const componentRef = ref<HTMLElement | null>(null);

const props = defineProps<{
  disabled?: boolean;
  showChevron: boolean;
}>();

const state = reactive({
  showDropdown: false,
});

watch(
  () => props.disabled,
  (disabled: boolean) => {
    if (disabled) {
      state.showDropdown = false;
    }
  },
);

const toggleDropdown = () => {
  if (props.disabled) return;
  state.showDropdown = !state.showDropdown;
};

// Hide notifications dropdown when clicking outside of it
window.addEventListener("click", (e) => {
  if (!componentRef.value?.contains(e.target as Node)) {
    state.showDropdown = false;
  }
});
</script>
